import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/form/button";
import { Helmet } from "react-helmet";

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="flex h-[100dvh] w-full flex-col items-center justify-center gap-4 text-slate-500 dark:text-slate-400">
            <Helmet>
                <title>ReinVB — 404</title>
            </Helmet>
            <img src="/images/page_not_found.svg" alt="Page not found" className="w-full max-w-sm" />
            <p>The page you searched is nowhere to be found...</p>
            <Button onClick={() => navigate(-2)} variant={"dark"}>
                Go back
            </Button>
        </div>
    );
}
